export default {
	title: 'Constraints',
	subtitle:
		'List the constraints that you have to take into account. They can be legal, technical, factual, political, budgetary and/or your targets. Note that you can weigh them. Then click « next ». You can also skip this step',
	no_description: 'No defined constraint',
	context_worse: 'Negative',
	context_best: 'Positive',
}
